module.exports = __webpack_public_path__ + "static/media/icon-withdraw.6b67e16d.svg";